import React from 'react'
import { FAQ } from 'services/ContentfulService/models/fact'
import { Partner } from 'services/ContentfulService/models/partner/partner'
import { Product } from 'services/ContentfulService/models/product'
import { Hero } from '../components/ExploreHero'
import { DebtConsolidationTile } from '../../../Calculators/DebtConsolidation/widgets'
import { PartnerSection } from 'experiences/learn/partners/PartnersSection'
import { FaqSection } from 'experiences/learn/common/FaqSection/FaqSection'
import { AccordianSection } from '../../common/sections/AccordianSection'
import { FeaturedPartners } from '../../common/sections/FeaturedPartners'
import { Container } from 'components/layout'
import { TopicsSection } from 'experiences/learn/topics/TopicsSection'
import { TrustpilotWidget } from 'components/vendor/TrustpilotWidget'
import { Topic } from 'services/ContentfulService/models/topics'
import { sortPartners, truncArray } from 'lib'
import { TrustpilotAside } from '../../common/sections/TrustpilotAside'
import { LoanIntroSection } from '../components/LoansIntroSection'
import { blockSectionProps, crossSellData, heroCopy } from 'experiences/explore/loans/ContentPage/content'
import styled from '@emotion/styled'
import { mediaQueriesByDevice } from 'parameters/viewport'

export interface LoansExplorePageProps {
	product: Product
	faqs: FAQ[]
	partners: Partner[]
	featuredPartners: Partner[]
	topics: Topic[]
}

export const LoansContentPage: React.FC<React.PropsWithChildren<LoansExplorePageProps>> = ({
	product,
	faqs,
	partners,
	featuredPartners,
	topics
}) => (
	<div>
		<Hero {...heroCopy} />
		<ExploreWrapper>
			<FeaturedPartners partners={featuredPartners} />
			<LoanIntroSection />
			<DebtConsolidationTile />
			<Container>
				<FaqSection faqs={truncArray(faqs, 3)} />
			</Container>
			<TrustpilotAside {...blockSectionProps} />
			<AccordianSection title="Not looking for a loan?" items={crossSellData} imageSrc="/images/loans-xsell.jpg" />
			<Container>
				<PartnerSection partners={partners.sort(sortPartners)} product={product} />
			</Container>
			<Container>
				<TopicsSection title="Learn About Loans" topics={truncArray(topics, 4)} linkTo="/learn/products/loans" />
			</Container>
			<Container>
				<TrustpilotWidget widget="carousel" />
			</Container>
		</ExploreWrapper>
	</div>
)

const ExploreWrapper = styled.div`
	padding-bottom: 24px;

	> div {
		width: 100%;
		margin-bottom: 80px;
	}

	${mediaQueriesByDevice.mobile} {
		> div {
			margin-bottom: 40px;
		}
	}
`
